<template>
  <div class="solutions-bg">
    <div class="solutions adaption">
      <div>
        <div class="headline himalaya">S<span>olutions</span></div>
        <span class="title">解决方案</span>
        <span class="text">为客户提供简单、适用、可靠的解决方案</span>
      </div>
    </div>
    <div class="item-container">
      <img v-lazy="require(`../../assets/index/solutions/bg-${index}.png`)" class="container-bg"/>
      <div class="adaption">
        <div v-for="i in item" :key="i.img" class="item" :class="i.img">
          <section @mouseout="active=index" @mouseover="active=i.img">
            <div class="card" :class="active===i.img?'active':''" @click="cardClick(i)">
              <img v-show="active === i.img"
                   v-lazy="require(`../../assets/index/solutions/${i.img}.svg`)">
              <div class="name">{{ i.name }}</div>
              <div v-show="active !== i.img" class="en-name">{{ i.enName }}</div>
            </div>
          </section>
        </div>
        <section class="introduce-section" :class="index === 'car' ? 'active' : ''">
          <div class="introduce">
            <div class="solutions-title himalaya">Automobile Intelligent Manufacturing</div>
            <div class="br-line"></div>
            <div class="solutions-des">
              随着我国制造业高质量发展的协同推进、工业互联网的全面发展，汽车制造借助互联网在信息化、智能化等诸多方面取得突破的同时也给工控系统安全带来了新的挑战。近年来工控安全事件频发，每年新发现工控系统漏洞数量维持在高位水平且大多为中高危的工控系统通用漏洞，这给控制系统密集型的汽车行业带来了极大的安全隐患。
            </div>
            <div class="Wayra solutions-button" @click="click">解决方案</div>
          </div>
          <img class="introduce-img" style="margin-bottom: 100px;"
               v-lazy="require('../../assets/index/solutions/introduce1.png')">
        </section>
        <section class="introduce-section" :class="index === 'power' ? 'active' : ''">
          <div class="introduce">
            <div class="solutions-title himalaya">Power system</div>
            <div class="br-line"></div>
            <div class="solutions-des">
              随着“互联网+电力”的深度耦合发展，电力生产对现场设备之间的信息互通提出了更高的要求，以工业以太网为代表的组网技术不断得到广泛应用，电力系统建设已不再是系统的简单集成，而是向网络化、智能化方向全面拓展。在两化融合、智能电网大趋势的背景下，电力企业工业控制系统的管理控制一体化、网络化、智能化已是大势所趋。
            </div>
            <div class="Wayra solutions-button" @click="click">解决方案</div>
          </div>
          <img class="introduce-img" v-lazy="require('../../assets/index/solutions/introduce2.png')">
        </section>
        <section class="introduce-section" :class="index === 'tobacco' ? 'active' : ''">
          <div class="introduce">
            <div class="solutions-title himalaya">Tobacco</div>
            <div class="br-line"></div>
            <div class="solutions-des">
              近十几年来，我国烟草制造历经多次大规模的技术改造，其各个工艺环节的自动化技术水平已经走在国内制造业，甚至是国际烟草企业的前列。很多国际领先的自动化技术和工控网络技术，像PROFINET、EthernetIP等进入中国都是率先在烟草制造业中应用。这些先进技术的应用在巨大提升烟草企业生产力的同时也埋下了极大的安全隐患。
            </div>
            <div class="Wayra solutions-button" @click="click">解决方案</div>
          </div>
          <img class="introduce-img" v-lazy="require('../../assets/index/solutions/introduce3.png')">
        </section>
        <section class="introduce-section" :class="index === 'water' ? 'active' : ''">
          <div class="introduce">
            <div class="solutions-title himalaya">Water Affairs</div>
            <div class="br-line"></div>
            <div class="solutions-des">
              随着人类社会的不断发展，城市规模的不断扩大，城市的用水需求日益增加，用水紧张和水质污染情况日益严重，造成环境问题日益突出。特别是在现代化的污水处理系统中，各生产装置都已间接或直接的接入到生产网络中，网络的安全性就变得尤为重要。
            </div>
            <div class="Wayra solutions-button" @click="click">解决方案</div>
          </div>
          <img class="introduce-img" v-lazy="require('../../assets/index/solutions/introduce4.png')">
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import {top} from "../../utils/common";

export default {
  name: "Solutions",
  data() {
    return {
      index: "car",
      active: "car",
      item: [
        {
          img: "car",
          name: "汽车智能制造",
          enName: "Intelligent Manufacturing"
        },
        {
          img: "power",
          name: "电力系统",
          enName: "Power System"
        },
        {
          img: "tobacco",
          name: "烟草",
          enName: "Tobacco"
        },
        {
          img: "water",
          name: "水务",
          enName: "Water Affairs"
        }
      ]
    };
  },
  methods: {
    click() {
      top();
      this.$router.push("/solution");
    },
    cardClick(value) {
      this.active = value.img;
      this.index = value.img;
    }
  }
};
</script>

<style scoped lang="less">
.solutions-bg {
  background-color: #F4F8FF;
}

.item-container {
  margin-top: 45px;
  width: 100%;
  height: 855px;
  background-color: #1D1E28;

  .container-bg {
    position: absolute;
  }

  & > div {
    position: relative;
    height: 100%;
    display: flex;
    align-items: flex-start;
  }

  .item {
    display: inline-block;
    width: 25%;
    height: 100%;
    border-right: 1px solid rgba(255, 255, 255, 0.1);

    .card {
      width: 80%;
      margin-right: auto;
      height: 124px;
      border-bottom: 2px solid #FFFFFF;
      color: #FFFFFF;
      cursor: pointer;

      .name {
        padding-top: 50px;
        padding-left: 20px;
        font-size: 24px;
      }

      .en-name {
        padding-left: 20px;
        font-size: 18px;
        opacity: 0.35;
      }

      &.active {
        transition: background 0.3s;
        text-align: right;
        background-color: #2851A5;
        border-bottom: 2px solid #2851A5;

        img {
          padding-top: 30px;
          padding-right: 20px;
        }

        .name {
          transition: background 0.3s, font-size 0.3s;
          padding: 0 20px 0 0;
          font-size: 32px;
          line-height: 32px;
        }
      }
    }
  }

  .introduce-section {
    position: absolute;
    top: 200px;
    display: flex;
    width: 100%;
    height: calc(100% - 200px);
    visibility: hidden;
    opacity: 0;

    &.active {
      transition: opacity 0.6s;
      visibility: visible;
      opacity: 1;
    }
  }

  .introduce {
    width: 50%;
    margin-top: 60px;

    .solutions-title {
      width: 563px;
      height: 80px;
      font-size: 80px;
      line-height: 50%;
      color: #FFFFFF;
    }

    .br-line {
      width: 76px;
      margin-top: 15px;
      border-bottom: 2px solid #929AB9;;
    }

    .solutions-des {
      //.lg({
      //    width: 563px;
      //});
      //.md({
      //    width: 563px;
      //});
      //.sm({
      //    width: 430px;
      //});
      margin-top: 100px;
      font-size: 18px;
      line-height: 180%;
      text-indent: 2em;
      text-align: justify;
      color: #FFFFFF;
    }

    .solutions-button {
      width: 162px;
      margin-top: 45px;
      font-size: 18px;
      text-align: center;
    }
  }

  .introduce-img {
    align-self: center;
    margin: auto;
  }
}

.solutions {
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .headline {
    margin-top: 90px;
    height: 85px;
    font-size: 120px;
    color: #929AB9;

    span {
      font-size: 70px;
    }
  }

  .title {
    font-size: 36px;
    color: #232E55;
  }

  .text {
    margin-left: 20px;
    font-size: 16px;
    color: #707783;
  }
}
</style>
